// src/pages/CourseTime/components/ErrorDialog.comp.jsx
import React from 'react';
import {
  ErrorDialogOverlay,
  ErrorDialogContainer,
  ErrorDialogHeader,
  ErrorDialogTitle,
  ErrorDialogCloseButton,
  ErrorDialogContent,
  ErrorDialogMessage,
  ErrorDialogActions,
  ErrorDialogButton
} from '../styles/common.styles';

// Error Icon Component
const ErrorIcon = () => (
  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

// Close Icon Component
const CloseIcon = () => (
  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

const ErrorDialog = ({ isOpen, onClose, errorMessage, title = "Error" }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <ErrorDialogOverlay onClick={handleOverlayClick}>
      <ErrorDialogContainer>
        <ErrorDialogHeader>
          <ErrorDialogTitle>
            <ErrorIcon />
            {title}
          </ErrorDialogTitle>
          <ErrorDialogCloseButton onClick={onClose}>
            <CloseIcon />
          </ErrorDialogCloseButton>
        </ErrorDialogHeader>
        <ErrorDialogContent>
          <ErrorDialogMessage>{errorMessage}</ErrorDialogMessage>
          <ErrorDialogActions>
            <ErrorDialogButton onClick={onClose}>Close</ErrorDialogButton>
          </ErrorDialogActions>
        </ErrorDialogContent>
      </ErrorDialogContainer>
    </ErrorDialogOverlay>
  );
};

export default ErrorDialog;

